import { TablesPageInfo } from '~/types'

export const initialPageInfo: TablesPageInfo = {
  endCursor: '',
  hasNextPage: false,
  hasPreviousPage: false,
  startCursor: ''
}
